<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { ProgressLines } from '@smatch/cassiopeia-web-components';

    /* PROPS ----------------------------------------------------------------------------------- */

    export let current: string | undefined;

    /* INTERNALS ------------------------------------------------------------------------------- */

    const STEPS = {
        step1: 'Step 1',
        step2: 'Step 2',
        step3: 'Step 3',
    };

</script>

<ProgressLines steps = { STEPS } { current } />